const IS_LEGACY_BROWSER = false;
let _ieVersion: number | null | false = null;

function getIEVersion() {
  if (_ieVersion == null) {
    if (typeof document === "undefined") {
      return;
    }

    const ie = (function () {
      let v = 3;
      const div = document.createElement("div");
      const all = div.getElementsByTagName("i");

      while (
        ((div.innerHTML = "<!--[if gt IE " + ++v + "]><i></i><![endif]-->"),
        all[0])
      );

      return v > 4 ? v : false;
    })();

    const ieVersion = (function () {
      const sAgent = window.navigator.userAgent;
      const Idx = sAgent.indexOf("MSIE");

      // If IE, return version number.
      if (Idx > 0)
        return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));
      // If IE 11 then look for Updated user agent string.
      else if (navigator.userAgent.match(/Trident\/7\./)) return 11;
      else return 0; //It is not IE
    })();

    if (typeof ieVersion === "number") {
      _ieVersion = ieVersion;
      return;
    }

    _ieVersion = ie;
  }
}

const BrowserService = {
  isLegacyBrowser() {
    if ((IS_LEGACY_BROWSER as unknown) === true) {
      return true;
    }

    getIEVersion();

    if (_ieVersion === 0) {
      return false;
    }

    return typeof _ieVersion === "number" && _ieVersion <= 11;
  },
  transitionsSupported() {
    const isLegacyBrowser = this.isLegacyBrowser();
    return !_ieVersion && isLegacyBrowser === false;
  },
  isCorsSupported() {
    getIEVersion();

    if (typeof _ieVersion !== "number" || _ieVersion >= 11) {
      return true;
    }

    return !this.isLegacyBrowser();
  },
};

export default BrowserService;
